if (!customElements.get("quick-add-modal")) {
	customElements.define(
		"quick-add-modal",
		class QuickAddModal extends ModalDialog {
			constructor() {
				super();
				this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			}

			hide(preventFocus = false) {
				const cartDrawer = document.querySelector("cart-drawer");
				if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
				this.modalContent.innerHTML = "";

				if (preventFocus) this.openedBy = null;
				super.hide();
			}

			show(opener) {
				opener.setAttribute("aria-disabled", true);
				opener.classList.add("loading");

				if (opener.querySelector(".loading-overlay__spinner")) {
					opener
						.querySelector(".loading-overlay__spinner")
						.classList.remove("hidden");
				}

				fetch(opener.getAttribute("data-product-url"))
					.then((response) => response.text())
					.then((responseText) => {
						const responseHTML = new DOMParser().parseFromString(
							responseText,
							"text/html"
						);
						this.productElement = responseHTML.querySelector(
							'section[id^="MainProduct-"]'
						);
						this.preventDuplicatedIDs();
						this.removeDOMElements();
						this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						if (window.ProductModel) window.ProductModel.loadShopifyXR();

						this.removeGalleryListSemantic();
						this.updateImageSizes();
						this.preventVariantURLSwitching();
						// Call the method to set up variant quantity rules
						this.setupVariantQuantityRules();
						super.show(opener);
					})
					.finally(() => {
						opener.removeAttribute("aria-disabled");
						opener.classList.remove("loading");

						if (opener.querySelector(".loading-overlay__spinner")) {
							opener
								.querySelector(".loading-overlay__spinner")
								.classList.add("hidden");
						}

						var slider = new Swiper(".js-media-list", {
							slidesPerView: 1,
							navigation: {
								nextEl: ".swiper-btn--next",
								prevEl: ".swiper-btn--prev",
							},
						});
					});
			}

			setInnerHTML(element, html) {
				element.innerHTML = html;

				// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
				element.querySelectorAll("script").forEach((oldScriptTag) => {
					const newScriptTag = document.createElement("script");
					Array.from(oldScriptTag.attributes).forEach((attribute) => {
						newScriptTag.setAttribute(attribute.name, attribute.value);
					});
					newScriptTag.appendChild(
						document.createTextNode(oldScriptTag.innerHTML)
					);
					oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
				});
			}

			removeDOMElements() {
				const pickupAvailability = this.productElement.querySelector(
					"pickup-availability"
				);
				if (pickupAvailability) pickupAvailability.remove();

				const productModal = this.productElement.querySelector("product-modal");
				if (productModal) productModal.remove();

				const gift = this.productElement.querySelector(".customer");
				if (gift) gift.remove();
			}

			preventDuplicatedIDs() {
				const sectionId = this.productElement.dataset.section;
				this.productElement.innerHTML =
					this.productElement.innerHTML.replaceAll(
						sectionId,
						`quickadd-${sectionId}`
					);
				this.productElement
					.querySelectorAll("variant-selects, variant-radios")
					.forEach((variantSelect) => {
						variantSelect.dataset.originalSection = sectionId;
					});
			}

			preventVariantURLSwitching() {
				if (this.modalContent.querySelector("variant-radios,variant-selects")) {
					this.modalContent
						.querySelector("variant-radios,variant-selects")
						.setAttribute("data-update-url", "false");
				}
			}

			removeGalleryListSemantic() {
				const galleryList = this.modalContent.querySelector(
					'[id^="Slider-Gallery"]'
				);
				if (!galleryList) return;

				galleryList.setAttribute("role", "presentation");
				galleryList
					.querySelectorAll('[id^="Slide-"]')
					.forEach((li) => li.setAttribute("role", "presentation"));
			}

			updateImageSizes() {
				const product = this.modalContent.querySelector(".product");
				const desktopColumns = product.classList.contains("product--columns");
				if (!desktopColumns) return;

				const mediaImages = product.querySelectorAll(".product__media img");
				if (!mediaImages.length) return;

				let mediaImageSizes =
					"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

				if (product.classList.contains("product--medium")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "605px");
				} else if (product.classList.contains("product--small")) {
					mediaImageSizes = mediaImageSizes.replace("715px", "495px");
				}

				mediaImages.forEach((img) =>
					img.setAttribute("sizes", mediaImageSizes)
				);
			}

			setupVariantQuantityRules() {
	console.log('QuickAddModal: init variant -> min-qty (range-text based)');

	// --- same normalization & mapping logic you provided ---
	const extractFirstInt = (str) => {
		if (!str) return null;
		const norm = String(str).replace(/\u2013|\u2014/g, '-').replace(/\s+/g, ' ');
		const m = norm.match(/(-?\d{1,4})/);
		return m ? parseInt(m[1], 10) : null;
	};

	const minFromRangeText = (rangeText) => {
		const first = extractFirstInt(rangeText);
		if (first === null) return 1;
		if (first >= 24) return 24;
		if (first >= 12) return 12;
		return 1;
	};
	// --------------------------------------------------------

	// Selectors (scoped to modal content)
	const VARIANT_BUTTON_SELECTOR = '.variant-button, label.variant-button, label[data-range]';
	const QUANTITY_INPUT_SELECTOR = 'input[name="quantity"], input[type="number"], .quantity-input input';
	const MINUS_BTN_SELECTORS = [
		'button[name="minus"]',
		'.quantity__button-minus',
		'.quantity__decrease',
		'.qty-decrease'
	];

	// find qty input (scoped inside modal content)
	const findQtyInput = () => {
		return (
			this.modalContent.querySelector(QUANTITY_INPUT_SELECTOR) ||
			this.modalContent.querySelector('input[name="quantity"]') ||
			this.modalContent.querySelector('input[type="number"]')
		);
	};

	const findMinusButton = (qtyInput) => {
		if (!qtyInput) return null;
		const container = qtyInput.closest('quantity-input') || qtyInput.closest('.product-form__quantity') || qtyInput.parentElement;
		if (!container) return null;
		for (const sel of MINUS_BTN_SELECTORS) {
			const b = container.querySelector(sel);
			if (b) return b;
		}
		return null;
	};

	// apply min and clamp similar to your function
	const applyMinAndClamp = (qtyInput, minQty, setValue = false) => {
		if (!qtyInput) return;
		qtyInput.min = minQty;
		qtyInput.setAttribute('min', String(minQty));
		let val = parseInt(qtyInput.value, 10);
		if (isNaN(val) || val < minQty || val === 0 || setValue) {
			qtyInput.value = minQty;
			qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
		}
		const minus = findMinusButton(qtyInput);
		if (minus) {
			if ((parseInt(qtyInput.value, 10) || 0) <= minQty) minus.setAttribute('disabled', 'disabled');
			else minus.removeAttribute('disabled');
		}
	};

	// sanitize user input & clamp on blur/change/paste
	const bindQtyInputEvents = (qtyInput) => {
		if (!qtyInput) return;
		// avoid re-binding
		if (qtyInput._variantQtyBound) return;
		qtyInput._variantQtyBound = true;

		qtyInput.addEventListener('input', function () {
			const raw = this.value.replace(/[^\d]/g, '');
			if (raw !== this.value) this.value = raw;
		});

		const clampHandler = function () {
			const min = parseInt(qtyInput.min, 10) || 1;
			let v = parseInt(qtyInput.value, 10) || 0;
			if (v < min) {
				qtyInput.value = min;
				qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
			const minus = findMinusButton(qtyInput);
			if (minus) {
				if ((parseInt(qtyInput.value, 10) || 0) <= min) minus.setAttribute('disabled', 'disabled');
				else minus.removeAttribute('disabled');
			}
		};
		qtyInput.addEventListener('blur', clampHandler);
		qtyInput.addEventListener('change', clampHandler);
		qtyInput.addEventListener('paste', () => setTimeout(clampHandler, 10));
	};

	// read label text for an option/radio/button element
	const labelForOption = (opt) => {
		if (!opt) return '';
		if (opt.tagName && opt.tagName.toLowerCase() === 'option') return opt.textContent.trim();
		const lbl = opt.closest && opt.closest('label') ? opt.closest('label') : (document.querySelector(`label[for="${opt.id}"]`) || null);
		if (lbl) return (lbl.dataset && lbl.dataset.range) ? lbl.dataset.range.trim() : lbl.textContent.trim();
		if (opt.getAttribute && (opt.getAttribute('data-range') || opt.getAttribute('aria-label'))) {
			return (opt.getAttribute('data-range') || opt.getAttribute('aria-label') || '').trim();
		}
		return (opt.value || '').toString().trim();
	};

	// core handler that inspects the modal for currently selected variant and applies min
	const handleSelection = (sourceElement) => {
		try {
			const qtyInput = findQtyInput();
			if (!qtyInput) return;
			bindQtyInputEvents(qtyInput);

			// Determine visible label text:
			// priority: select[name="id"] selected option -> checked radio -> clicked label/button with data-range -> first .variant-button active
			let labelText = '';

			// select
			const sel = this.modalContent.querySelector('select[name="id"]');
			if (sel) {
				const opt = sel.options[sel.selectedIndex];
				labelText = labelForOption(opt || sel);
			} else {
				// checked radio
				const checked = this.modalContent.querySelector('input[name="id"]:checked, input[type="radio"]:checked');
				if (checked) {
					labelText = labelForOption(checked);
				} else {
					// if sourceElement provided (e.g., click), try it
					if (sourceElement) {
						labelText = labelForOption(sourceElement);
					}
					// fallback to first visible variant button/label
					if (!labelText) {
						const firstBtn = this.modalContent.querySelector(VARIANT_BUTTON_SELECTOR);
						if (firstBtn) labelText = labelForOption(firstBtn);
					}
				}
			}

			const minQty = minFromRangeText(labelText);
			applyMinAndClamp(qtyInput, minQty, true);
		} catch (err) {
			console.error('QuickAddModal: handleSelection error', err);
		}
	};

	// Handler registry for cleanup
	this._variantQty = this._variantQty || { attached: false, handlers: [], observer: null };

	// detach previous handlers if present
	if (this._variantQty.attached) {
		this._variantQty.handlers.forEach(({ el, ev, fn }) => {
			try { el.removeEventListener(ev, fn); } catch (e) {}
		});
		this._variantQty.handlers = [];
		if (this._variantQty.observer) {
			try { this._variantQty.observer.disconnect(); } catch (e) {}
			this._variantQty.observer = null;
		}
		this._variantQty.attached = false;
	}

	// Attach handlers (selects, radios, variant buttons)
	const attachHandlers = () => {
		// variant buttons / labels (click)
		const btns = Array.from(this.modalContent.querySelectorAll(VARIANT_BUTTON_SELECTOR));
		btns.forEach((btn) => {
			const fn = (ev) => {
				handleSelection(btn);
			};
			btn.addEventListener('click', fn);
			this._variantQty.handlers.push({ el: btn, ev: 'click', fn });
		});

		// native selects
		const selects = Array.from(this.modalContent.querySelectorAll('select[name="id"]'));
		selects.forEach((s) => {
			const fn = () => handleSelection(s);
			s.addEventListener('change', fn);
			s.addEventListener('click', fn); // to handle re-click
			this._variantQty.handlers.push({ el: s, ev: 'change', fn });
			this._variantQty.handlers.push({ el: s, ev: 'click', fn });
		});

		// radios
		const radios = Array.from(this.modalContent.querySelectorAll('input[name="id"][type="radio"], variant-radios input[type="radio"]'));
		radios.forEach((r) => {
			const fn = () => handleSelection(r);
			r.addEventListener('change', fn);
			r.addEventListener('click', fn);
			this._variantQty.handlers.push({ el: r, ev: 'change', fn });
			this._variantQty.handlers.push({ el: r, ev: 'click', fn });
		});

		// theme event
		const themeFn = (evt) => {
			try {
				// prefer variant.title or option text when present
				if (evt.detail && evt.detail.variant && (evt.detail.variant.title || evt.detail.variant.option1)) {
					const label = evt.detail.variant.title || evt.detail.variant.option1;
					const qtyInput = findQtyInput();
					if (qtyInput) {
						const minQty = minFromRangeText(label);
						applyMinAndClamp(qtyInput, minQty, true);
					}
				} else {
					handleSelection(evt.target || null);
				}
			} catch (err) {
				console.error('QuickAddModal: theme variant:change handler error', err);
			}
		};
		this.modalContent.addEventListener('variant:change', themeFn);
		this._variantQty.handlers.push({ el: this.modalContent, ev: 'variant:change', fn: themeFn });

		this._variantQty.attached = true;

		// apply initial once handlers are attached
		setTimeout(() => handleSelection(null), 40);
	};

	// Observe modal content for injected selects/radios/labels (they arrive after HTML injection)
	const observer = new MutationObserver(() => {
		const found = this.modalContent.querySelector('select[name="id"], input[name="id"], label[data-range], .variant-button');
		if (found) {
			observer.disconnect();
			this._variantQty.observer = null;
			attachHandlers();
		}
	});
	observer.observe(this.modalContent, { childList: true, subtree: true });
	this._variantQty.observer = observer;

	// fallback timed attach
	setTimeout(() => {
		const exists = this.modalContent.querySelector('select[name="id"], input[name="id"], label[data-range], .variant-button');
		if (exists && !this._variantQty.attached) attachHandlers();
	}, 150);
}

		}
	);
}